import styled from 'styled-components';

export const GradualQuestionnaireMainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const GradualSliderWrapper = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const GradualProgressWrapper = styled.div`
  margin-bottom: 25px;
  padding: 16px 20px;
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
`;
